var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticStyle:{"overflow":"hidden","overflow-x":"hidden","overflow-y":"hidden","height":"80%","width":"80%","position":"absolute"},attrs:{"src":"https://report.koosha.ir/d/RvRHmj2Vz/test-pakshoma?orgId=1&refresh=5m&from=1645872398150&to=1677408398150&var-Province=All&var-query0=&var-City=All","frameborder":"0","height":"150%","width":"150%"}})])
}]

export { render, staticRenderFns }